import { throttle } from './Util.js';

class FixedHeader {
    constructor() {
        this.html = document.getElementsByTagName('html')[0];
        this.prevScroll = 0;

        this.bindEvents();
        this.detectTop();
    }

    /**
     * Если это не самый верх страницы,
     * добавляем хедеру тень и фон
     */
    detectTop() {
        if (window.scrollY > 0) {
            this.html.classList.add('_is-scroll-top');
        } else {
            this.html.classList.remove('_is-scroll-top');
        }
    }


    /**
     * При скролле вниз прячем хедер,
     * при скроле вверх — показываем
     */
    toggleVisible() {
        const scrollTop = window.scrollY;

        if (this.prevScroll > scrollTop || scrollTop < 1) {
            this.html.classList.remove('_is-header-hidden');
        } else {
            this.html.classList.add('_is-header-hidden');

            // Закрываем выбор языка
            document.querySelector(`.js-lang-dropdown`).classList.remove('_is-visible'); 
            App.langIsOpen = false;
        }

        this.prevScroll = scrollTop;

        this.detectTop();
    }


    bindEvents() {
        window.addEventListener('scroll', throttle(this.toggleVisible.bind(this), 30));
    }
}

new FixedHeader();



// WEBPACK FOOTER //
// ./_src/js/FixedHeader.js